import { atomWithStorage } from 'jotai/utils';
export const isLoggedIn = true as const;
export const unLoggedIn = false as const;
const beforeLoginCheck = undefined;
type AuthType = typeof isLoggedIn | typeof unLoggedIn | typeof beforeLoginCheck;
export const authAtom = atomWithStorage<AuthType>('auth', beforeLoginCheck);
export const authTokenAtom = atomWithStorage<string | undefined>('authToken', undefined)
export const authRefreshTokenAtom = atomWithStorage<string | undefined>('authRefreshToken', undefined)
export const authTokenTypeAtom = atomWithStorage<string | undefined>('authTokenType', undefined)